/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Trend_EnoughInputs */

const en_us2_body_assessment_trend_enough = /** @type {(inputs: Body_Assessment_Trend_EnoughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This estimate is good enough to follow your trend over time. Take it the same way each time and the direction is reliable. A lab test is optional, not something you owe.`)
};

const pt_br2_body_assessment_trend_enough = /** @type {(inputs: Body_Assessment_Trend_EnoughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta estimativa já é boa o bastante para acompanhar a sua evolução ao longo do tempo. Refazendo sempre do mesmo jeito, a direção é confiável. Um exame de laboratório é opcional, não uma pendência sua.`)
};

const es_419_body_assessment_trend_enough = /** @type {(inputs: Body_Assessment_Trend_EnoughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta estimación es suficiente para seguir tu evolución con el tiempo. Si la haces siempre de la misma manera, la dirección es confiable. Un estudio de laboratorio es opcional, no algo que debas.`)
};

const pt_pt2_body_assessment_trend_enough = /** @type {(inputs: Body_Assessment_Trend_EnoughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta estimativa já é suficientemente boa para acompanhar a tua evolução ao longo do tempo. Se a repetires sempre da mesma forma, a direção é fiável. Um exame de laboratório é opcional, não uma pendência tua.`)
};

const fr_fr2_body_assessment_trend_enough = /** @type {(inputs: Body_Assessment_Trend_EnoughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette estimation suffit pour suivre ton évolution dans le temps. Refais-la toujours de la même façon et la tendance est fiable. Un examen en laboratoire est facultatif, pas une obligation.`)
};

const de_de2_body_assessment_trend_enough = /** @type {(inputs: Body_Assessment_Trend_EnoughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Schätzung reicht, um deinen Verlauf über die Zeit zu verfolgen. Mach sie jedes Mal gleich, dann ist die Richtung verlässlich. Ein Labortest ist optional, keine Pflicht.`)
};

const it_it2_body_assessment_trend_enough = /** @type {(inputs: Body_Assessment_Trend_EnoughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa stima è già abbastanza buona per seguire il tuo andamento nel tempo. Rifacendola sempre allo stesso modo, la direzione è affidabile. Un esame di laboratorio è facoltativo, non un dovere.`)
};

/**
* | output |
* | --- |
* | "This estimate is good enough to follow your trend over time. Take it the same way each time and the direction is reliable. A lab test is optional, not someth..." |
*
* @param {Body_Assessment_Trend_EnoughInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_trend_enough = /** @type {((inputs?: Body_Assessment_Trend_EnoughInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Trend_EnoughInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_trend_enough(inputs)
	if (locale === "es-419") return es_419_body_assessment_trend_enough(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_trend_enough(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_trend_enough(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_trend_enough(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_trend_enough(inputs)
	return en_us2_body_assessment_trend_enough(inputs)
});
export { body_assessment_trend_enough as "body-assessment.trend_enough" }